import { useFetchUserDetails } from "../modules/auth/hooks/auth.queries";
import { getClientSession } from "../utils/clientSessionStore";

export default function useCurrentClientProfile() {
    const { data: userDetails } = useFetchUserDetails();
    const user = userDetails?.data;
    const { clientId, userId, practice } = getClientSession();

    const currentUserId = userId || user?.user_id || "";

    if (!clientId || !user || !practice) return null;

    const isMainUser = user.user_id === currentUserId;

    const profile = isMainUser
        ? user
        : user.sub_profiles?.find((p) => p.user_id === currentUserId);

    if (!profile) return null;

    return {
        firstName: profile.first_name,
        lastName: profile.last_name,
        preferredName: profile.preferred_name,
        dateOfBirth: profile.date_of_birth,
        currentProfileId: clientId,
        userId: currentUserId,
        practice,
    };
}
